import axios from "axios";

export const acceptSupervisionInvite = async (inviteToken: string) => {
  try {
    const token = localStorage.getItem("token");

    const res = await axios.put(
      `${process.env.REACT_APP_URL}/supervisors/accept-invite`,
      {
        token: inviteToken,
      },
      {
        headers: {
          "Content-Type": "application/json",
          "X-Client-Type": "web",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return { data: res.data, error: null };
  } catch (error: any) {
    return { error: error.response?.data, data: null };
  }
};

export const declineSupervisionInvite = async (inviteToken: string) => {
  try {
    const res = await axios.put(
      `${process.env.REACT_APP_URL}/supervisors/decline-invite`,
      {
        token: inviteToken,
      },
      {
        headers: {
          "Content-Type": "application/json",
          "X-Client-Type": "web",
        },
      }
    );

    return { data: res.data, error: null };
  } catch (error: any) {
    return { error: error.response?.data, data: null };
  }
};
